export const bankOptions = [
  { value: 'ธนาคารกรุงไทย', label: 'ธนาคารกรุงไทย' },
  { value: 'ธนาคารกสิกรไทย', label: 'ธนาคารกสิกรไทย' },
  { value: 'ธนาคารไทยพาณิชย์', label: 'ธนาคารไทยพาณิชย์' },
  { value: 'ธนาคารออมสิน', label: 'ธนาคารออมสิน' },
  { value: 'ธนาคารกรุงเทพ', label: 'ธนาคารกรุงเทพ' },
  { value: 'ธนาคารกรุงศรีอยุธยา', label: 'ธนาคารกรุงศรีอยุธยา' },
  { value: 'ธนาคารทหารไทยธนชาต', label: 'ธนาคารทหารไทยธนชาต' },
  { value: 'ธนาคารเกียรตินาคินภัทร', label: 'ธนาคารเกียรตินาคินภัทร' },
  { value: 'ธนาคารซีไอเอ็มบีไทย', label: 'ธนาคารซีไอเอ็มบีไทย' },
  { value: 'ธนาคารยูโอบี', label: 'ธนาคารยูโอบี' },
]

export const bankAccountTypeOptions = [
  { value: 'ออมทรัพย์', label: 'ออมทรัพย์' },
  { value: 'กระแสรายวัน', label: 'กระแสรายวัน' },
]
